import WritingCompetition from "./writingCompetition";

export default WritingCompetition;